@if (form) {
  <div [formGroup]="form">
    <!-- Activity roster -->
    @if (isAutoAssignAllowed && form.controls.activityPriority.value.type === activityPriorityType.NormalActivity) {
      <div>
        <div class="cord-label">
          <label class="label">
            {{ 'ACTIVITY_ROSTER' | translate }}
            @if (form.controls.rosterStudents.value?.length > 0) {
              <span class="heading-count">
                {{ form.controls.rosterStudents.value.length }}
              </span>
            }
          </label>
        </div>
        <div class="info-list-message mb-3">
          <div class="mr-1">
            <i class="ftmi-info"></i>
          </div>
          <div class="ml-1 text-left">
            {{'REGISTRATION_IS_OPEN_FOR_ALL_STUDENTS' | translate}}
          </div>
        </div>
      </div>
    }
    @if (!isAutoAssignAllowed && this.form.controls.activityPriority.value.type === activityPriorityType.NormalActivity) {
      <div>
        <div class="cord-label">
          <label class="label">
            {{ 'ACTIVITY_ROSTER' | translate }}
          </label>
        </div>
        <div class="empty-list-message" role="status" aria-live="polite">
          {{ 'ATTENDANCE_OPEN_FOR_ALL_STUDENTS' | translate }}
        </div>
      </div>
    }
    <!-- Roster students -->
    @if (form.controls.activityPriority.value.type !== activityPriorityType.NormalActivity || isAutoAssignAllowed) {
      <div class="mb-5">
        <!-- WCAG 1.3.1 — h2 under page h1; .h3 keeps prior h3 typography -->
        <h2 class="h3">
          {{ 'ROSTER_STUDENTS' | translate }}
          @if (form.controls.rosterStudents.value?.length > 0) {
            <span class="heading-count">
              {{ form.controls.rosterStudents.value.length - form.controls.excludedStudents.value.length }}
              <span class="total"> / {{ form.controls.rosterStudents.value.length }} </span>
            </span>
          }
        </h2>
        <div class="app-input-inline rel">
          <!-- WCAG 3.3.2 — id matches labelElementId on app-auto-complete-list-by-selection; for matches inputId (NgSelectA11yDirective). -->
          <label id="activity-default-roster-combobox-a11y-label" for="activity-default-roster-combobox">
            {{ 'DEFAULT_ROSTER' | translate }}
          </label>
          @if (this.form.controls.defaultRoster.value) {
            <div class="edit-roster">
              <button
                type="button"
                class="round-btn round-btn-xs"
                (click)="onEditRoster()"
                [disabled]="isDisabled"
                appSchoolYearDisabled
                [appTooltip]="'EDIT' | translate"
                [attr.aria-label]="'EDIT' | translate"
                >
                <i class="ftmi-edit text-primary" aria-hidden="true"></i>
              </button>
            </div>
          }
          <app-auto-complete-list-by-selection
            inputId="activity-default-roster-combobox"
            labelElementId="activity-default-roster-combobox-a11y-label"
            [ariaLabel]="'DEFAULT_ROSTER' | translate"
            (selectedItemChange)="onSelectChangeRoster($event)"
            (searchChange)="onSearchChangeRoster($event)"
            [itemsData]="rosters"
            (clearChange)="onClearChange()"
            [selectedItem]="form.controls.defaultRoster.value"
            [searchOnClick]="true"
            [minTermLength]="0"
            [isDisabled]="isDisabled"
            (addNewGroup)="onAddNewGroupClicked()"
            [showAddNewGroupButton]="true"
          ></app-auto-complete-list-by-selection>
        </div>
        <ul class="list-group list-group-select">
          @for (item of form.controls.rosterStudents.value; track item) {
            <li
              (click)="!isDisabled && onUpdateExclusions(item)"
              [class.deselected]="isStudentExcluded(item)"
              class="list-group-item"
              [class.disabled]="isDisabled"
              >
              <b class="mr-3">{{ item.user.firstName }} {{ item.user.lastName }}</b>
              {{ item.email }}
              @if (!isStudentExcluded(item)) {
                <span class="ml-auto text-primary" aria-hidden="true">
                  <i class="ftmi-check" aria-hidden="true"></i>
                </span>
              }
            </li>
          }
        </ul>
        @if (!form.controls.rosterStudents.value.length) {
          <div class="empty-list-message" role="status" aria-live="polite">
            {{ 'SELECT_A_GROUP_TO_POPULATE_LIST' | translate}}
          </div>
        }
        <app-form-error [control]="form.controls.defaultRoster"></app-form-error>
      </div>
    }
    <!-- Additional students -->
    @if (form.controls.activityPriority.value.type !== activityPriorityType.NormalActivity) {
      <div class="mb-5">
        <h2 class="h3">
          {{ 'ADDITIONAL_STUDENTS' | translate }}
          @if (form.controls.rosterStudents.value?.length > 0) {
            <span class="heading-count">
              {{ form.controls.additionalStudents.value.length }}
            </span>
          }
        </h2>
        <app-auto-complete-list-group-student [form]="form" (selectChange)="onSelectChangeAdditionalStudent($event)"
        ></app-auto-complete-list-group-student>
      </div>
    }
  </div>
}
